var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('keep-alive',[(_vm.isReading)?_vm._t("reading"):_vm._e(),(_vm.isCreation)?_vm._t("creation"):_vm._e()],2),(_vm.isPreview)?_vm._t("preview"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }